<template>
  <router-view id='app'/>
</template>
<script>
</script>